import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, Checkbox, Button, message } from 'antd';
import validationRegex from '../../utils/validationRegex';

import AllEmployeesQuery from '../../graphql/queries/AllEmployeesQuery.graphql';
import StoreEmployeeMutation from '../../graphql/mutations/StoreEmployeeMutation.graphql';

const FormItem = Form.Item;

const formItemLayout = {
  labelCol: {
    xs: { span: 2 },
  },
  wrapperCol: {
    xs: { span: 8 },
  },
};

const submitBtnLayout = {
  wrapperCol: {
    xs: {
      offset: 2,
    },
  },
};

class CreateEmployee extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.mutate({
          variables: { ...values },
          update: (proxy, { data: { storeEmployee } }) => {
            // Read the data from our cache for this query.
            const data = proxy.readQuery({ query: AllEmployeesQuery });

            // Add our todo from the mutation to the end.
            data.employees.push(storeEmployee);

            // Write our data back to the cache.
            proxy.writeQuery({ query: AllEmployeesQuery, data });
          },
        })
          .then(() => {
            message.success('Employee added!');
            this.props.history.goBack();
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="container-fluid">
        <h2>Add new employee</h2>
        <div className="ec-content-box">
          <Form onSubmit={this.handleSubmit}>
            <FormItem
              hasFeedback
              label="Full Name"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        type: 'string',
                        message: 'Employee\'s full name is required!',
                      },
                    ],
                  },
                )(<Input />)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Email address"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'email',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Employee\'s email is required!',
                      },
                      {
                        type: 'email',
                        message: 'Incorrect email entered!',
                      },
                    ],
                  },
                )(<Input />)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Mobile number"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'mobile',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Employee\'s mobile is required!',
                      },
                      {
                        pattern: validationRegex.mobile,
                        message: 'Incorrect mobile number entered!',
                      },
                    ],
                  },
                )(<Input addonBefore="+91" />)
              }
            </FormItem>
            <FormItem
              hasFeedback
              label="Designation"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'designation',
                  {
                    rules: [
                      {
                        type: 'string',
                        message: 'Incorrect designation entered!',
                      },
                    ],
                  },
                )(<Input />)
              }
            </FormItem>
            <FormItem
              label="Is Admin"
              {...formItemLayout}
            >
              {
                getFieldDecorator(
                  'isAdmin',
                  {
                    initialValue: false,
                    valuePropName: 'checked',
                  },
                )(<Checkbox>Select if you want to make this employee an Admin</Checkbox>)
              }
            </FormItem>
            <FormItem {...submitBtnLayout}>
              <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}

CreateEmployee.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
};

export default compose(
  graphql(StoreEmployeeMutation),
  Form.create(),
)(CreateEmployee);



// WEBPACK FOOTER //
// ./src/pages/employees/CreateEmployee.jsx